import {useRouteError} from 'react-router-dom';
import {logger} from './helperFunctions';

export default function ErrorPage() {
  const error = useRouteError();
  logger(error);

  return (
    <div id='error-page'>
      <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred.</p>
      <p>
        <i>{error.statusText || error.message}</i>
      </p>
    </div>
  );
}
